/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import "./filterDropDown.styles.css";
import { hasSelectedFilters } from "helpers";
import { configConstants,LLM_CONSTANTS } from "constants/configCategory";
import { consoleLog } from "helpers";
const hasFilterSelected = (filterName, selectedFilters) => {
  return selectedFilters[filterName] && selectedFilters[filterName] !== "";
};

const FilterDropdown = ({ filters, onFilterSelect, finalFilters = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(finalFilters);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const [expandedFilter, setExpandedFilter] = useState(null);

  useEffect(() => {
    if (isOpen) setSelectedFilters(finalFilters);
  }, [isOpen]);

  const handleFilterClick = (filterName, value) => {
    setSelectedFilters((prev) => {
      consoleLog(["entering firt loop here"]);
      if (prev?.[filterName] === value) {
        consoleLog(["entering here"]);
        return { ...prev, [filterName]: "" };
      }
      return {
        ...prev,
        [filterName]: value,
      };
    });
  };

  useEffect(() => {
    consoleLog([selectedFilters, "selectedFilters"]);
  }, [selectedFilters]);

  const handleSubmit = useCallback(() => {
    onFilterSelect?.(selectedFilters);
    setIsOpen(false);
  }, [onFilterSelect, selectedFilters]);

  const handleTouchEnd = useCallback(
    (e) => {
      e.preventDefault(); // Prevent ghost clicks on iOS
      setIsOpen(!isOpen);
    },
    [isOpen]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleTouchStart = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Add both mouse and touch event listeners
    document.addEventListener("touchstart", handleTouchStart, {
      passive: true,
    });
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: "fixed",
        top: `${rect.bottom + window.scrollY}px`,
        left: `${rect.left + window.scrollX}px`,
        zIndex: 9999,
      });
    }
  }, [isOpen]);



  return (
    <div className="relative" ref={dropdownRef}>
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        onTouchEnd={handleTouchEnd}
        className={`flex items-center gap-2 rounded-md border px-4 py-2 text-sm font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:!bg-gray-10 dark:text-white ${
          isOpen || hasSelectedFilters(finalFilters)
            ? "border-blue-500 bg-blue-50 text-blue-600 ring-2 ring-blue-500 ring-offset-2"
            : "border-gray-300 text-gray-700 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-600"
        }`}
        style={{
          WebkitTapHighlightColor: "transparent", // Remove tap highlight on iOS
          touchAction: "manipulation", // Optimize touch behavior
        }}
      >
        <span>
          Filters
          {hasSelectedFilters(finalFilters)
            ? ` (${
                Object?.keys(finalFilters)?.filter(
                  (key) => finalFilters[key] !== ""
                ).length
              })`
            : ""}
        </span>
        {isOpen ? (
          <FiChevronUp className="h-4 w-4" />
        ) : (
          <FiChevronDown className="h-4 w-4" />
        )}
      </button>

      {isOpen && (
        <div
          style={{
            ...dropdownStyle,
            WebkitOverflowScrolling: "touch",
          }}
          className="w-80 rounded-md border border-gray-200 bg-white p-4 shadow-lg dark:!bg-gray-10 dark:text-white"
        >
          <div className="custom-scrollbar max-h-[30dvh] overflow-y-auto overflow-x-hidden">
            {filters.map((filter) => (
              <div key={filter.name} className="mb-[1.5px] w-full">
                <button
                  onClick={() =>
                    setExpandedFilter(
                      expandedFilter === filter.name ? null : filter.name
                    )
                  }
                  className={`flex w-full items-center justify-between rounded-md px-3 py-[7px] transition-colors duration-200  ${
                    hasFilterSelected(filter.name, selectedFilters)
                      ? "bg-blue-50 text-blue-600 hover:bg-blue-100 dark:!bg-gray-10 dark:text-white"
                      : "hover:bg-gray-50 "
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <h3
                      className={`truncate font-medium capitalize ${
                        hasFilterSelected(filter.name, selectedFilters)
                          ? "text-blue-600"
                          : "text-gray-700"
                      }`}
                    >
                      {filter.name}
                    </h3>
                  </div>
                  <FiChevronDown
                    className={`h-4 w-4 flex-shrink-0 transform transition-transform duration-200 ${
                      expandedFilter === filter.name ? "rotate-180" : ""
                    } ${
                      hasFilterSelected(filter.name, selectedFilters)
                        ? "text-blue-600"
                        : "text-gray-500"
                    }`}
                  />
                </button>

                {expandedFilter === filter.name && (
                  <div className="mt-2 w-full space-y-2 pl-2 dark:!bg-gray-10 dark:text-white">
                    {filter.data
                      .map((value) => {
                        if (value === true) return "Active";
                        if (value === false) return "Inactive";
                        return String(value);
                      })
                      .map((value) => {
                        const displayLabel =
                          filter.name === "category"
                            ? configConstants.find((c) => c.value === value)
                                ?.type || value
                            : filter.name === "LLM"
                            ? LLM_CONSTANTS.find((c) => c.value === value)
                                ?.type || value
                            : value;

                        return (
                          <label
                            key={value}
                            className={`flex w-full cursor-pointer items-center gap-2 rounded-md p-2 
          text-sm transition-all duration-200 hover:bg-gray-50 ${
            selectedFilters[filter.name] === value
              ? "bg-blue-50 font-medium text-blue-600"
              : "text-gray-600 hover:text-gray-900"
          }`}
                          >
                            <input
                              readOnly
                              type="radio"
                              className="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                              checked={selectedFilters[filter.name] === value}
                              onClick={() =>
                                handleFilterClick(filter.name, value)
                              }
                            />
                            <span className="truncate">
                              {displayLabel.length < 25
                                ? displayLabel
                                : `${displayLabel.slice(0, 25)}...`}
                            </span>
                          </label>
                        );
                      })}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Filter Actions */}
          <div className="mt-4 flex justify-end gap-2 border-t pt-4">
            <button
              onClick={() => {
                setSelectedFilters({});
                onFilterSelect?.({});
                setIsOpen(false);
              }}
              className="rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium
              text-gray-600 transition-all duration-200 ease-in-out hover:border-gray-400 
              hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 
              focus:ring-gray-400 focus:ring-offset-2 active:scale-95 active:transform"
            >
              Clear
            </button>
            <button
              onClick={handleSubmit}
              className="rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white 
              shadow-sm transition-all duration-200 ease-in-out hover:bg-blue-700 
              hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 
              focus:ring-offset-2 active:scale-95 active:transform 
              disabled:cursor-not-allowed disabled:opacity-50"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
